import { Component } from '@angular/core';
import { Facet } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { FacetService } from '../../../../shared/services/facet.service';

@Component({
  selector: 'app-facet-drop-down',
  templateUrl: './facet-drop-down.component.html',
  providers: [FacetService],
  standalone: true,
})
export class FacetDropDownComponent extends GenericBaseModelDropDown<Facet> {

  constructor(
    private service: FacetService) {
    super(service, "Facet");
  }

}
